const MANADER = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/** '2026-10-13' → '13 okt 2026' (eller '13 okt' när utanAr). */
export function formateraDatum(iso, utanAr = false) {
  if (!iso) return '';
  const [ar, man, dag] = String(iso).split('-');
  if (!ar || !man || !dag) return iso;
  return `${Number(dag)} ${MANADER[Number(man) - 1] || ''}${utanAr ? '' : ` ${ar}`}`;
}

export function dagarSedan(iso, idag = new Date()) {
  if (!iso) return Infinity;
  const d = new Date(`${iso}T00:00:00`);
  return Math.floor((idag - d) / 86400000);
}

// Områdesordning i biblioteket (samma som i komponentspecen).
export const OMRADEN = [
  'Projekt',
  'Arbetsmiljö och kvalitet',
  'Ekonomi och inköp',
  'Personal',
  'Ledningssystem',
  'KanAI',
];

export function gallerText(galler) {
  return galler === 'Dator och Field' ? 'datorn och Field-appen' : 'datorn';
}
